module.exports = __webpack_public_path__ + "img/grid-5.7796693b.svg";